<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { MOBILEIDENAVIGATIONIDS } from '@/utils/ide'
import { useNavStore } from '@/stores/nav.store'
import { useIdeStore } from '@/stores/ide.store'

import SolutionsMegaMenu from '@/components/header/navigation/SolutionsMegaMenu.vue'
import ResourcesMegaMenu from '@/components/header/navigation/ResourcesMegaMenu.vue'
import CodeSearchBar from '@/components/code/CodeSearchBar.vue'
import Logo from '@/components/utils/LogoComp.vue'

const ideStore = useIdeStore()
const navStore = useNavStore()

/**
 * @param event Click event
 * If clicking outside of dropdown div, dropdown will disappear
 */
const clickEventHandler = (event: any) => {
  const mobileIdeNavigation = document.getElementById(MOBILEIDENAVIGATIONIDS.IDENAVIGATION)

  if (navStore.showMobileNav) {
    if (
      mobileIdeNavigation &&
      !mobileIdeNavigation.contains(event.target) &&
      event.target.id != MOBILEIDENAVIGATIONIDS.MENUDARKETLOGOID &&
      event.target.id != MOBILEIDENAVIGATIONIDS.CODESEARCHBARID
    ) {
      navStore.setMobileNav(false)
    } else {
      navStore.setMobileNav(true)
    }
  }
}

onMounted(() => {
  document.addEventListener('click', clickEventHandler)
})

onUnmounted(() => {
  navStore.setMobileNav(false)
  document.removeEventListener('click', clickEventHandler)
})
</script>

<template>
  <div
    v-if="ideStore.currentMobileTab != null"
    :id="MOBILEIDENAVIGATIONIDS.IDENAVIGATION"
    class="border-primary surface-primary-base absolute left-0 order-2 flex h-full w-full min-w-[13.5rem] flex-col gap-2 overflow-auto border-r p-1 [--adaptive:none] [--strategy:static] [--trigger:click] lg:flex lg:h-full lg:flex-row lg:items-center lg:gap-0 lg:[--strategy:absolute]"
  >
    <div>
      <Logo />
      <CodeSearchBar
        :isWithAnimation="true"
        :is-full-size="false"
        :isMini="true"
        :isIdeMobileNav="true"
      />
    </div>
    <!-- Solutions -->
    <div
      class="hs-dropdown w-full [--adaptive:none] [--strategy:static] [--trigger:click] lg:flex lg:items-center lg:[--strategy:absolute]"
    >
      <button
        type="button"
        class="flex w-full items-center justify-between px-3 py-1 lg:rounded-md lg:px-2"
      >
        Solutions
        <FontAwesomeIcon
          icon="fa-chevron-right"
          class="ml-2 mr-2 h-3 w-3 lg:mr-0 lg:h-2.5 lg:w-2.5"
        />
      </button>
      <SolutionsMegaMenu />
    </div>

    <!-- Resources -->
    <div
      class="hs-dropdown [--adaptive:none] [--strategy:static] [--trigger:click] lg:flex lg:items-center lg:[--strategy:absolute]"
    >
      <button
        type="button"
        class="flex w-full items-center justify-between px-3 py-1 lg:rounded-md lg:px-2"
      >
        Resources
        <FontAwesomeIcon
          icon="fa-chevron-right"
          class="ml-2 mr-2 h-3 w-3 lg:mr-0 lg:h-2.5 lg:w-2.5"
        />
      </button>
      <ResourcesMegaMenu />
    </div>

    <!-- Pricing -->
    <div class="w-full">
      <RouterLink class="flex w-full items-center px-3 py-1 lg:rounded-md lg:px-2" to="/pricing">
        Pricing
      </RouterLink>
    </div>
  </div>
</template>
